module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-introduction/i2-z7-8406fa61e2bb1ec36941bddc23ee3803.svg";